import { Validator } from 'vee-validate';
Validator.extend('fa', {
    getMessage: field => 'مقدار ' + field + ' باید تنها شامل حروف فارسی باشد',
    validate: value => /^([\u0600-\u06FF\uFB8A\u067E\u0686\u06AF\u200C ])+$/.test(value)
});
Validator.extend('mobile', {
    getMessage: field => 'مقدار ' + field + ' نا معتبر است',
    validate: value => /^(\+98|0098|98|0)?9\d{9}$/g.test(value)
});
Validator.extend('phone', {
    getMessage: field => 'مقدار ' + field + ' نا معتبر است',
    validate: value => /^((\+98|0098|98|0)\d1)?\d{8}$/g.test(value)
});
Validator.extend('username', {
    getMessage: field => 'مقدار ' + field + ' نا معتبر است',
    validate: value => /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,29}$/igm.test(value)
});
const dictionary = {
    fa: {
        messages: {
            required: (fieldName) => {
                return ` ${fieldName} نباید خالی باشد`
            },
            fa: (fieldName) => {
                return ` ${fieldName} باید تنها شامل حروف فارسی باشد `
            },
            phone: (fieldName) => {
                return ` ${fieldName} نا معتبر است `
            },
            mobile: (fieldName) => {
                return ` ${fieldName} نا معتبر است `
            },
            min: (fieldName, params) => {
                return `${fieldName} حداقل ${params} کاارکتر است `
            },
            max: (fieldName, params) => {
                return `${fieldName} حداکثر ${params} کاارکتر است `
            },
            min_value: (fieldName, params) => {
                return `${fieldName} حداقل مقدار ${params} است `
            },
            max_value: (fieldName, params) => {
                return `${fieldName} حداکثر مقدار ${params} است `
            },
            numeric: (fieldName) => {
                return `مقدار غیر عددی برای ${fieldName} نا معتبر است `
            },
            length: (fieldName, params) => {
                return `${fieldName} باید ${params} کارکتر باشد `
            },
            included: (fieldName ) => {
                return `${fieldName} باید یک مقدار معتبر باشد `
            },
            email: (fieldName ) => {
                return `${fieldName} معتبر نیست `
            },
            url: (fieldName ) => {
                return `${fieldName} معتبر نیست `
            },
            username: (fieldName ) => {
                return `${fieldName} معتبر نیست `
            },
        },
        attributes: {
            fname: 'نام',
            name: 'نام',
            lname: 'نام خانوادگی',
            fullname: 'نام و نام خانوادگی دریافت کننده',
            phone: 'تلفن ثابت',
            mobile: 'تلفن همراه',
            province: 'استان',
            state: 'استان',
            city: 'شهر',
            zip: 'کد پستی',
            address : 'آدرس',
            sex : 'جنسیت',
            email : 'ایمیل',
            ncode : 'کد ملی',
            birth_date : 'تاریخ تولد',
            marriage_date : 'تاریخ ازدواج',
            bank : 'شماره حساب',
            website : 'وبسایت',
            instagram : 'نام کاربری اینستاگرام',
            financial_code : 'کد مالی',
        }
    }
};
export {dictionary}